import Vue from 'vue'

/*Router*/
import Router from 'vue-router';
import Route from '../src/router/index';

/*Vuex*/
import Vuex from 'vuex';
import Store from '../src/vuex';

/*Multilanguage*/
//var VueMultilanguage = require('vue-multilanguage');
import VueMultilanguage from '../node_modules/vue-multilanguage/src/vue-multilanguage';

/*Loeading des langues*/
/*let l = {};
Store.state.locales.forEach(function(value, index){
  System.ready = System.import(`../src/traduction/`+ value).then(function(data){
    l[value] = data.default;
  });
});
Vue.use(VueMultilanguage, l);*/

import fr from '../src/traduction/fr';
import en from '../src/traduction/en';
import it from '../src/traduction/it';
import es from '../src/traduction/es';
Vue.use(VueMultilanguage, {
  fr: fr,
  en: en,
  it: it,
  es: es
});

/*Resource*/
import VueResource from 'vue-resource';
Vue.use(VueResource);

/*APPLICATION*/
import App from '../src/Index.vue'

/*Permet d'attendre que les scripts de langue sont chargé avant de lancer l'apply */
//System.ready.then(function() { 
new Vue({
  el: '#app',
  store: Store,
  router: Route,
  render: h => h(App)
});  
//});


// WEBPACK FOOTER //
// ./src/main.ts